import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const FacebookIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 20;
  const color = props.color || 'white';
  return <Icon name={'facebook'} size={size} color={color} />;
};

export default React.memo(FacebookIcon);
